<template>
  <div :class="{ registerWrap: isRegister }">
    <v-card
      :max-width="maxWidth"
      :min-width="minWidth"
      class="rounded-lg"
      :class="{ 'mx-auto mt-16': !isRegister, registerCard: isRegister }"
    >
      <v-container fluid>
        <v-row no-gutters>
          <v-col>
            <v-img
              class="mx-auto mt-5"
              :src="require('@/assets/logo_spes_large.svg')"
              max-width="140"
            />
          </v-col>
        </v-row>
        <v-row no-gutters justify="center" align-content="center">
          <v-col>
            <div
              class="primary--text font-weight-bold text-center registerTitle"
            >
              {{ title }}
            </div>
          </v-col>
        </v-row>
        <v-row
          v-if="description"
          no-gutters
          justify="center"
          align-content="center"
          class="pb-7"
        >
          <v-col cols="10">
            <div class="text-center descriptionFont">
              {{ description }}
            </div>
          </v-col>
        </v-row>
        <slot />
        <v-row
          v-if="loginLink"
          no-gutters
          class="py-5"
          justify="center"
          align-content="center"
        >
          <v-col v-if="isShowToLogin">
            <div class="primary--text text-center">
              <NormalLink :text="$t('common.input_to-login')" link="/login" />
            </div>
          </v-col>
        </v-row>
      </v-container>
    </v-card>
    <div class="footerFont text-center" :class="{ isRegister }">
      {{ 'Language: ' }}
      <select
        v-model="selectLang"
        class="Rectangle langFont pl-2"
        @change="onClickLang()"
      >
        <option
          v-for="(item, index) in items"
          :key="index"
          :value="item.config"
        >
          <span>{{ item.title }}</span>
        </option>
      </select>
    </div>
    <div class="footerFont text-center mb-5" :class="{ isRegister }">
      ©Spes Co.,Ltd. All Right Reserved.
    </div>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
import { NormalLink } from '@/components/items'
import { langConfig } from '@/config'
import axios from 'axios'

export default {
  components: {
    NormalLink
  },
  props: {
    title: { default: '' },
    maxWidth: { default: '360' },
    minWidth: { default: 'auto' },
    loginLink: { default: 'true' },
    description: { default: '' },
    isShowToLogin: {
      type: Boolean,
      default: true
    },
    isRegister: {
      type: Boolean,
      default: false
    }
  },
  data: () => {
    return {
      //
      selectLang: '',
      items: [
        { config: langConfig.LANG_JA, title: '日本語' },
        { config: langConfig.LANG_CN, title: '簡体中文' }
      ]
    }
  },
  methods: {
    ...mapActions('Common', ['setLang']),
    onClickLang() {
      this.$i18n.locale = this.selectLang
      axios.defaults.params = { lang: this.$i18n.locale }
      this.setLang(this.selectLang)
      this.$router.go({ path: this.$router.currentRoute.path, force: true })
    }
  },
  created() {
    this.selectLang = this.$i18n.locale
  }
}
</script>
<style lang="scss" scoped>
.registerTitle {
  font-size: 16px !important;
  margin-top: 39px;
  margin-bottom: 28px;
}
.footerFont {
  color: #cccccc;
  margin-top: 20px;
}
.descriptionFont {
  color: #666666;
}
.Rectangle {
  width: 80px;
  height: 24px;
  border-radius: 12px;
  border: solid 1px #ddd;
  background-color: #fff;
}
.langFont {
  color: #999;
}
.registerWrap {
  display: flex;
  flex-direction: column;
  height: 100vh;
  overflow-y: auto;
  overflow-x: hidden;
  border-left: 1px solid #ccc;
  box-sizing: border-box;
}
.registerCard {
  box-shadow: none !important;
  margin: 0 29.45px;
}
.isRegister {
  max-width: 360px;
  margin: 0 auto 1rem;
}
</style>
